import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useResourcesList } from "../../ResourcesList/resourcesList";
import { useMapContext } from "../MapContext";

import { unselectItem } from "../../../reducers/resourcesList/selection";

export const useMapUsersFiltering = refetch => {
  const { mapKey } = useMapContext();

  const activeUserFields = useSelector(({ map }) => map[mapKey].filters.activeUserFields);
  const dispatch = useDispatch();
  const { resourcesListKey } = useResourcesList();

  const isFirstRenderingRef = useRef(true);

  useEffect(() => {
    // Avoid refetching the whole dataset during the first render, as we only want this
    // useEffect hook to be run once the filters are updated.
    if (isFirstRenderingRef.current) {
      isFirstRenderingRef.current = false;
      return;
    }

    const userFields = Object.keys(activeUserFields).map(fieldId => ({
      id: fieldId,
      value: activeUserFields[fieldId]
    }));

    dispatch(unselectItem(resourcesListKey));

    refetch({ usersMapUsersFilters: { userFields } });
  }, [refetch, activeUserFields, dispatch, resourcesListKey]);
};
